module.exports = __webpack_public_path__ + "img/chf.0d44ccc4.webp";